import { render } from "./TShaped.vue?vue&type=template&id=a9f54732&scoped=true&ts=true"
import script from "./TShaped.vue?vue&type=script&lang=ts"
export * from "./TShaped.vue?vue&type=script&lang=ts"

import "./TShaped.vue?vue&type=style&index=0&id=a9f54732&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9f54732"]])

export default __exports__